import { NavBar } from "../component/NavBar.jsx"
import { SideBar } from "../component/SideBar.jsx"

export const ProviderReportPage = ()=>{
    return (
        <div>
        <NavBar/>
        <SideBar selector="provider-report"/>
        <div className="container">
            <h1>Reports</h1>
            Provider Report content </div>
        
        </div>
    )
};